/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Payment_BankInputs */

const vi_receipt_payment_bank = /** @type {(inputs: Receipt_Payment_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển khoản`)
};

/**

* @param {Receipt_Payment_BankInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_payment_bank = /** @type {((inputs?: Receipt_Payment_BankInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Payment_BankInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_payment_bank(inputs)
});